module.exports = __webpack_public_path__ + "img/descfactura.c3b892b9.png";